module.exports = __webpack_public_path__ + "img/infront_logo.609f82be.jpg";